import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid} from '@material-ui/core';
import SearchInput from 'Components/common/SearchInput';
import CustomerCard from 'Components/lto/order/CustomerCard';
import Header from 'Components/common/Header';
import {T} from 'Actions/translate';
import BackTop from 'Components/common/BackTop';
import {
    updateDetachedFlag,
    updateShowOtherCustomerButton,
    updateIsLastPage,
    getB2bPlatformCustomerList,
} from 'Actions/customer';
import {updateProductSearchFields, getShipToOfNotSC} from 'Actions/order';
import ScrollWrapper from 'Components/lto/common/ScrollWrapper';
import {setUserData} from 'Actions/localData';
import LoadingIcon from 'Components/icons/LoadingIcon';
import util from 'Utils/commonUtil';

class SelectCustomer extends Component {
    pager = {
        customer: {
            pageNum: 0,
            pageSize: 10,
            pageTotal: 9999999999999,
        },
    };

    state = {
        detachedFlag: false,
        listLoaded: true,
        pageLoad: true,
        searchValue: '',
    };

    constructor() {
        super();

        this.searchBtn = React.createRef();
    }

    async componentDidMount() {
        window.scrollTo(0, 0);

        this.getList();
    }

    getList = (params, flag) => {
        if (this.state.listLoaded === false) return;

        this.setState({listLoaded: false});

        if (flag) {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }

        this.props
            .getB2bPlatformCustomerList({
                pageNum:
                    params && params.queryKey.trim()
                        ? 1
                        : flag
                        ? 1
                        : this.pager.customer.pageNum + 1,
                pageSize: this.pager.customer.pageSize,
                queryKey: this.state.searchValue,
            })
            .then((res) => {
                this.pager.customer.pageNum = flag ? 1 : res.pageNum;
                this.pager.customer.pageSize = res.pageSize;
                this.pager.customer.pageTotal = res.pageTotal || 1;

                this.setState({listLoaded: true});
            })
            .catch((res) => {
                this.setState({listLoaded: true});
            });
    };

    handleChange = (name, value) => {
        this.setState({[name]: value});
    };

    handleSearch = async () => {
        this.pager.customer.pageNum = 1;
        await this.props.updateDetachedFlag(false);
        await this.props.updateShowOtherCustomerButton(false);
        await this.props.updateIsLastPage(false);

        let searchParam = {
            queryKey: this.state.searchValue
                ? this.state.searchValue.trim()
                : '',
        };

        this.getList(searchParam, true);
    };

    gotoUsercenter = () => this.props.history.push('/usercenter');

    setUserDataHandle = (customerDetails) => {
        const {localData} = this.props;
        this.props.setUserData({
            data: {
                email: customerDetails.email,
                shipToNum: customerDetails.shipToNo,
                isProxyProcess: true,
                type: localData.roleType,
                name: localData.name,
            },
        });
        this.props.history.push('/productList?isProxyUser=1');
    };

    goBack = () => this.props.history.goBack();

    render() {
        const {b2bPlatformShipToList} = this.props;

        return (
            <div className="select-customer">
                <div className="container-max-width is-fixed background"></div>
                <div className="container-max-width is-fixed background-cover"></div>

                <Header
                    hasArrowBackIos={true}
                    hasUserCenter={true}
                    backEvent={this.goBack}>
                    <Grid
                        className="page-title-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid className="page-title" item xs={11}>
                            <span>{T('selectCustomer')}</span>
                        </Grid>
                    </Grid>

                    <Grid
                        className="page-search-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid className="page-search" item xs={11}>
                            <SearchInput
                                title={'searchValue'}
                                onChange={this.handleChange}
                                placeholder={T('searchB2bPlatformCustomer')}
                                search={this.handleSearch}
                            />
                        </Grid>
                    </Grid>
                </Header>

                <ScrollWrapper
                    listLoaded={this.state.listLoaded}
                    showLoadingMore={!this.state.listLoaded}
                    showAbyss={
                        this.pager.customer.pageNum >=
                        this.pager.customer.pageTotal
                    }
                    getMoreData={this.getList}>
                    {this.state.listLoaded &&
                        b2bPlatformShipToList.length === 0 && (
                            <Grid className="customer-list" item xs={11}>
                                <div className="notFound">
                                    {' '}
                                    - {T('notFoundCustomer')} -{' '}
                                </div>
                            </Grid>
                        )}
                    <Grid
                        className="customer-list-container no-margin"
                        container
                        spacing={0}
                        justify={'center'}>
                        {b2bPlatformShipToList.map((customer, i) => (
                            <Grid
                                className="customer-list"
                                key={'customer' + i}
                                item
                                xs={11}>
                                <CustomerCard
                                    customerDetails={customer}
                                    locked={null}
                                    fromB2bPlatform={true}
                                />
                            </Grid>
                        ))}
                    </Grid>
                    <BackTop />
                </ScrollWrapper>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {customer, localData} = state;
    return {
        detachedFlag: customer.detachedFlag,
        isLastPage: customer.isLastPage,
        b2bPlatformShipToList: customer.b2bPlatformShipToList,
        localData: localData,
    };
};

const mapDispatchToProps = {
    updateDetachedFlag,
    updateShowOtherCustomerButton,
    updateIsLastPage,
    updateProductSearchFields,
    getShipToOfNotSC,
    getB2bPlatformCustomerList,
    setUserData,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectCustomer);
